<template>
  <el-container>
    <el-header class="my-el-header">
      <div class="header">
        <div class="jzq-logo">
          <!-- <img src="/images/ptlogo.png"/> -->
        </div>
      </div>
    </el-header>
    <div class="y-header" style="height: 60px;"></div>
    <el-main :style="{ 'min-height': height, padding: 0 }">
      <nuxt />
    </el-main>
  </el-container>
</template>

<script>
import {ding_erformance} from "./js/entConsoleDate.js"
export default {
  data() {
    return {
      height: "835px"
    };
  },
  mounted() {
    this.height = document.body.clientHeight - 100 + "px";
    ding_erformance()
  },
  methods: {},
  name: "headernomsg"
};
</script>

<style lang="less" scoped>
.my-el-header {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  /*z-index: 2;*/
  z-index: 500;
  height: 60px !important;
  background-color: #ec1c1c;
  color: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(38, 38, 38, 0.35);
}

.header {
  margin: 0 auto;
  .jzq-logo {
    height: 60px;
    line-height: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// layouts/headernomsg.vue